// src/components/PlayerUI.js
import React from 'react';
import Keypad from './Keypad'; // Pastikan Keypad.js ada di folder yang sama

const ScoreIndicator = ({ gameType, score }) => {
    if (gameType === 'panjat-pinang') {
        return (
            <div className="score-indicator">
                Benar: <span className="score-value">{score}/7</span>
            </div>
        );
    }
    if (gameType === 'balap-karung') {
        return (
            <div className="score-indicator">
                Posisi: <span className="score-value">{score}/10</span>
            </div>
        );
    }
    // Tarik Tambang tidak memiliki score indicator
    return null;
};

function PlayerUI({ player, playerState, setPlayerState, onCheckAnswer, mathMode, gameType }) {
    const { question, answer, status, score } = playerState;
    const playerSideClass = `${player}-player`; // 'left-player' atau 'right-player'

    const handleKeyPress = (key) => {
        if (key === 'Go') {
            if (answer && answer !== '-') {
                onCheckAnswer();
            }
            return;
        }

        if (key === 'C') {
            setPlayerState(prev => ({ ...prev, answer: '' }));
            return;
        }

        if (key === '-') {
            setPlayerState(prev => ({
                ...prev,
                answer: prev.answer.startsWith('-') ? prev.answer.slice(1) : '-' + prev.answer
            }));
            return;
        }

        if (key === '.') {
            if (!answer.includes('.') && answer.length > 0) {
                setPlayerState(prev => ({ ...prev, answer: prev.answer + '.' }));
            }
            return;
        }

        // Handle number keys
        if (answer.length < 5) {
            setPlayerState(prev => ({ ...prev, answer: prev.answer + key }));
        }
    };
    
    // Menentukan kelas dinamis untuk kotak jawaban
    const answerBoxClass = `answer-box ${status}`; // 'answer-box correct' atau 'answer-box wrong'

    return (
        <div className={`player-section ${playerSideClass}`}>
            <div className="question-box">
                {question ? `${question} = ?` : 'Memuat soal...'}
            </div>
            <div className={answerBoxClass}>
                {answer}
            </div>
            
            <Keypad onKeyPress={handleKeyPress} mathMode={mathMode} />
            
            <ScoreIndicator gameType={gameType} score={score} />
        </div>
    );
}

export default PlayerUI;